module.exports = __webpack_public_path__ + "static/media/logo_color.448b3dd1.svg";